import "react";
import { Textarea } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikTextarea.tsx
var FormikTextarea = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => /* @__PURE__ */ jsx(Textarea, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			...field,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChange: (e) => {
				if (props.onChange) props.onChange(e);
				field.onChange(e);
			}
		})
	});
};
//#endregion
export { FormikTextarea };

//# sourceMappingURL=FormikTextarea.js.map